"use client";

import { useEffect } from "react";

export function MobileScrollLock() {
  useEffect(() => {
    const lockClass = "swipe-scroll-lock";
    const body = document.body;
    const media = window.matchMedia("(max-width: 640px)");

    const toggle = () => {
      if (media.matches) {
        body.classList.add(lockClass);
      } else {
        body.classList.remove(lockClass);
      }
    };

    toggle();
    media.addEventListener("change", toggle);
    return () => {
      body.classList.remove(lockClass);
      media.removeEventListener("change", toggle);
    };
  }, []);

  return null;
}
